import { render, staticRenderFns } from "./shop_account_log.vue?vue&type=template&id=af25cb44&scoped=true"
import script from "./shop_account_log.vue?vue&type=script&lang=ts"
export * from "./shop_account_log.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af25cb44",
  null
  
)

export default component.exports